import React, { useEffect, useState } from "react";
import { Container, Grid, Typography, Box, Alert, Skeleton } from "@mui/material";
import { useHistory } from "react-router-dom";
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';

// Componentes
import SubscriptionCard from "../../../components/client/subscriptions/SubscriptionCard";

// Controlador
import { getMySubscriptions } from "../../../controllers/customer/subscriptions/ClientSubscriptionController";
import CustomBreadcrumbs from "../../../components/breadcrumbs";
import SectionTitle from "../../../components/sectionTitle";

export default function MySubscriptions() {
    const [subscriptions, setSubscriptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            const response = await getMySubscriptions();
            if (response.success) {
                setSubscriptions(response.data);
            }
            setIsLoading(false);
        };
        fetchData();
    }, []);

    const handleCardClick = (subscriptionId) => {
        // Navegar al detalle/historial (Lo haremos en el siguiente paso)
        history.push(`/subscriptions/detail/${subscriptionId}`);
    };

    return (
        <Container maxWidth="xl" sx={{ mb: 8 }}>
            <CustomBreadcrumbs
                returnTo='/'
                crumbs={[{name:'Suscripciones',link:'/subscriptions'}]}
            />
            <SectionTitle
                title='Mis suscripciones'
                subtitle={`Gestiona tus planes activos y revisa tus pagos pendientes.`}
            />

            {isLoading ? (
                // SKELETONS DE CARGA
                <Grid container spacing={3}>
                    {[1, 2, 3].map((i) => (
                        <Grid item xs={12} md={6} lg={4} key={i}>
                            <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2 }} />
                        </Grid>
                    ))}
                </Grid>
            ) : subscriptions.length > 0 ? (
                // LISTA DE TARJETAS
                <Grid container spacing={3}>
                    {subscriptions.map((sub) => (
                        <Grid item xs={12} md={6} lg={4} key={sub.id}>
                            <SubscriptionCard 
                                subscription={sub} 
                                onClick={() => handleCardClick(sub.id)}
                            />
                        </Grid>
                    ))}
                </Grid>
            ) : (
                // ESTADO VACÍO
                <Box display="flex" flexDirection="column" alignItems="center" mt={5}>
                    <SentimentDissatisfiedIcon sx={{ fontSize: 60, color: 'text.secondary', mb: 2 }} />
                    <Typography variant="h6" color="textSecondary">
                        No tienes suscripciones activas.
                    </Typography>
                </Box>
            )}
        </Container>
    );
}